import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { FollowUpButtons } from 'aem-libs-react-ts/src/components/calculators'
import LanguageDetector from 'aem-libs-react-ts/src/services/LanguageDetector'

import { RF_FOLLOW_UP } from '../constants'
import { contextSelector } from '../store/selectors'

const FollowUp = () => {
  const { t } = useTranslation()

  const { userTracking, paramsStatic } = useSelector(contextSelector)

  const handleCallMeClick = () => userTracking.onClick('callback')
  const handleBranchClick = () => userTracking.onClick('branch')

  return (
    <FollowUpButtons.Container>
      <FollowUpButtons.Button
        rf={RF_FOLLOW_UP.CALL_ME}
        link={paramsStatic.callMeLink[LanguageDetector()]}
        label={t('CALL_ME')}
        iconClass='csas-ico_callback'
        note={t('CALL_ME_MESSAGE')}
        onClick={handleCallMeClick}
      />
      <FollowUpButtons.Button
        rf={RF_FOLLOW_UP.BRANCH}
        link={paramsStatic.branchOrderLink[LanguageDetector()]}
        label={t('BRANCH_ORDER')}
        iconClass='csas-ico_home'
        note={t('BRANCH_ORDER_MESSAGE')}
        onClick={handleBranchClick}
      />
    </FollowUpButtons.Container>
  )
}

export default FollowUp
